import { $api } from "../AxiosInstance";

export class EmailService {
  static async getMailsOnProcessInfo() {
    return await $api.get("/api/email/getInfo");
  }

  static async getEmailTemplatesByLocale() {
    return await $api.get("/api/admin/emailTemplate/all/groupBy/locale");
  }

  static async getEmailTemplateById(id) {
    return await $api.get("/api/admin/emailTemplate", {
      params: { id },
    });
  }

  static async saveEmailTemplateById(
    id,
    name,
    locale,
    subject,
    text,
    dateFormatTemplateId,
    ipStatus,
    hasIpList
  ) {
    return await $api.post("/api/admin/emailTemplate", {
      id,
      locale,
      name,
      subject,
      text,
      dateFormatTemplateId,
      ipStatus,
      hasIpList,
    });
  }

  static async deleteEmailTemplate(id) {
    return await $api.delete("/api/admin/emailTemplate", { params: { id } });
  }

  static async getAllDateFormats() {
    return await $api.get("/api/admin/dateFormatTemplate/all");
  }

  static async getDateFormatById(id) {
    return await $api.get("/api/admin/dateFormatTemplate", { params: { id } });
  }

  static async saveDateFormatById(id, template) {
    return await $api.post("/api/admin/dateFormatTemplate", { id, template });
  }

  static async createDateFormat(template) {
    return await $api.put("/api/admin/dateFormatTemplate", { template });
  }

  static async deleteDateFormat(id) {
    return await $api.delete("/api/admin/dateFormatTemplate", { params: { id } });
  }

  // Email Template V2
  static async getAllMailTemplatesV2() {
    return await $api.get("/api/admin/emailTemplateV2/all");
  }

  static async getMailTemplateByIdV2(id) {
    return await $api.get("/api/admin/emailTemplateV2", { params: { id } });
  }

  static async saveMailTemplateV2(params) {
    return await $api.post("/api/admin/emailTemplateV2", params);
  }

  static async viewMailTemplateV2(params) {
    return await $api.post("/api/admin/emailTemplateV2/view", params);
  }

  static async sendTestEmailV2(params) {
    return await $api.post("/api/admin/emailTemplateV2/test", params);
  }

  // Spam
  static async getSpamTemplate() {
    return await $api.get("/api/admin/emailTemplateV2/getSpamTemplate");
  }

  static async saveSpamTemplate(params) {
    return await $api.post("/api/admin/emailTemplateV2/setSpamTemplate", params);
  }

  static async sendSpam(params) {
    return await $api.post("/api/email/sendSpam", params);
  }

  static async checkSpam(params) {
    return await $api.post("/api/email/view", params);
  }

  static async getCurentAmountMembers(params) {
    return await $api.get("/api/email/getInfo/filter", { params });
  }

  static async sendSpamTest(params) {
    return await $api.post("/api/email/sendTest", params);
  }
}
